module.exports = __webpack_public_path__ + "img/undraw_male_avatar_323b.d20d64ce.svg";